import store from "../index.js"

const state = {
	badgenum: 0,
}
const mutations = {
	addNum: function(state) {
		state.badgenum = state.badgenum + 1;
		// uni.setTabBarBadge({
		// 	index: 1,
		// 	text: String(state.badgenum)
		// })
	},
}
const actions = {
	async updateUserInfo(context) {
		let res = await http.get({
			url: '/flowUser/flowUser/getByID',
			data: {
				id: uni.getStorageSync('userInfo').id
			}
		})
		context.commit('updateUserInfo',res)
	}
}
export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js